import {Record} from 'immutable';

const SimpleLogin = new Record({
    loginId: null,
    name: null,
    image: null,
});

const fromAPI = simpleLogin => {
    return new SimpleLogin({
        ...simpleLogin,
    });
};

export default {
    default: new SimpleLogin(),
    record: SimpleLogin,
    fromAPI,
};
